import { BaseWebComponentDataProvider } from '../../../framework/BaseWebComponentDataProvider';
import { AiChatData } from '../types';

export class AiChatBaseDataProvider extends BaseWebComponentDataProvider {
  async getDataForView(): Promise<AiChatData> {
    throw new Error('Not implemented');
  }
}
